/** Seeded RNG so the simulation reproduces identically on client and server. */
export class Rng {
  private s: number;
  constructor(seed = 0x9e3779b9) {
    this.s = seed >>> 0;
  }
  next(): number {
    this.s = (this.s + 0x6d2b79f5) >>> 0;
    let t = this.s;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
  int(min: number, max: number): number {
    return min + Math.floor(this.next() * (max - min + 1));
  }
  /** Rolls `count`d`sides`. 2d6 clusters around 7; flat randomness does not. */
  roll(count: number, sides: number): number {
    let total = 0;
    for (let i = 0; i < count; i++) total += this.int(1, sides);
    return total;
  }
}

export interface Dice {
  count: number;
  sides: number;
  flat?: number;
}

export function rollDice(rng: Rng, d: Dice): number {
  return rng.roll(d.count, d.sides) + (d.flat ?? 0);
}

export function diceLabel(d: Dice): string {
  return `${d.count}d${d.sides}${d.flat ? `+${d.flat}` : ''}`;
}

export function diceAverage(d: Dice): number {
  return d.count * ((1 + d.sides) / 2) + (d.flat ?? 0);
}
